// Imported as modules (not /step-1.jpg from publicDir) so Vite bundles + hashes
// them and rewrites the URL correctly in BOTH builds: the standalone Cloudflare
// page AND the copy bundled into the extension (where publicDir is the repo
// root, so a publicDir reference would 404).
import step1 from './assets/step-1.jpg';
import step2 from './assets/step-2.jpg';

export function WelcomeApp() {
  return (
    <main className="welcome">
      <h1 className="welcome__heading">Website feedback tool is installed 🎉</h1>

      <section className="welcome__block">
        <div className="welcome__lines">
          <p className="welcome__text">
            <strong>Open the extensions menu (1)</strong> — click the puzzle
            icon in the top-right of your toolbar.
          </p>
          <p className="welcome__text">
            <strong>Pin the extension (2)</strong> — click the pin next to{' '}
            <em>Website feedback tool</em> so it stays in the toolbar.
          </p>
        </div>
        <img
          className="welcome__image"
          src={step1}
          width={1512}
          height={640}
          alt="Browser toolbar with extensions menu open and pin button highlighted"
        />
      </section>

      <section className="welcome__block">
        <p className="welcome__text">
          <strong>Click the extension icon (3)</strong> on any page to start a
          review — comment on elements, capture regions, and share as a link
          or HTML.
        </p>
        <img
          className="welcome__image"
          src={step2}
          width={1512}
          height={640}
          alt="Browser toolbar with the Website feedback tool icon highlighted"
        />
      </section>
    </main>
  );
}
